import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'comment-section',
  templateUrl: './comment-section.component.html',
  styleUrls: ['./comment-section.component.scss']
})
export class CommentSectionComponent implements OnInit {

  @Input('item') item;

  @ViewChild('fileInput') fileInput: ElementRef<HTMLElement>;

  constructor(
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
  }


  
  //#region Document
  openFileDialog() {
    this.fileInput.nativeElement.click();
  }

  fileChange(event, item) {
    // Reads the file choosen by the user
    var reader2 = new FileReader();
    var src: string;
    reader2.onload = (e) => {
      src = reader2.result.toString();
      let documentName = event.target.files[0].name;
      let documentType = src.substring(0, src.indexOf(",") + 1);
      let documentSrc = src.replace(documentType, "");
      let files;
      if (!item.FilesStatic_Id) {
        files = [];
      }
      else {
        files = item.FilesStatic_Id.split(';');
      }
      if (!files.find(x => x == documentName)) {
        // upload it to the server
        this.saveDocumentInServer(item, event.target.files[0], documentName);
      }
    }
    reader2.readAsDataURL(event.target.files[0]);
  }

  saveDocumentInServer(item, file, documentName) {
    this.generalService.uploadFile2(<File>file, documentName)
      .subscribe((res: any) => {
        if (res && res.fileName) {
          // add it to file list
          this.getImagesFromFilesStatic_Id(item, res);
        }
      }, error => {
        // Mock the response because of an error in backend for testing purposes
        var res = { fileName: documentName };
        if (res && res.fileName) {
          this.getImagesFromFilesStatic_Id(item, res);
        }
      });
  }

  getImagesFromFilesStatic_Id(item, res) {
    // add it to file list
    let files;
    if (!item.FilesStatic_Id) {
      files = [];
    }
    else {
      files = item.FilesStatic_Id.split(';');
    }
    files.push(res.originalName);
    item.FilesStatic_Id = files.join(';');
  }
  //#endregion
}
